import React from 'react'
import { Col, List, Row, Select } from 'antd'

import { RequestQuoteVehicle } from 'src/types'
import { Text } from 'src/components/Ant'
import CurrencyMask from 'src/components/Formik/InputCurrency/mask'
import Images from 'src/config/images'

function ListItemVehicleHistory({ item }: { item: RequestQuoteVehicle }) {
  const style = item.chosen
    ? {
        background: '#b7eb8f',
        border: '1px dashed #e8e8e8',
        borderRadius: 4,
        overflow: 'hidden',
        padding: 16
      }
    : {}
  const totalValue = `BRL ${
    CurrencyMask({
      formatStr: true,
      value: item.total_value
    }).maskedValue
  }`

  return (
    <List.Item key={item.request_quote_vehicle_hash} style={style}>
      <List.Item.Meta
        avatar={
          <div
            style={{
              alignItems: 'center',
              display: 'flex',
              justifyContent: 'center',
              position: 'relative',
              width: 200
            }}
          >
            <img
              alt="logo"
              src={
                item.vehicle_image_url ? item.vehicle_image_url : Images.noImage
              }
              style={{ maxHeight: 200, maxWidth: 200 }}
            />
            {!!item.company_image_url && (
              <img
                alt="logo"
                src={item.company_image_url}
                style={{
                  left: 0,
                  maxHeight: 70,
                  maxWidth: 70,
                  position: 'absolute',
                  top: 0
                }}
              />
            )}
          </div>
        }
        title={item.model}
        description={
          <Row gutter={24}>
            <Col span={15}>
              <span>-{item.gearbox}</span>
              <br />
              <span>-{item.information}</span>
              <br />
              {item.air_conditioning && (
                <span>
                  {'- '}
                  <Text
                    onlyText
                    title="web.services.vehicle.form.air-conditioning"
                  />
                </span>
              )}
              <br />
            </Col>
            <Col
              offset={1}
              span={8}
              style={{ display: 'flex', flexDirection: 'column' }}
            >
              <Select defaultValue={totalValue}>
                <Select.Option
                  key={item.request_quote_vehicle_unique}
                  title={totalValue}
                  value={item.request_quote_vehicle_unique}
                >
                  {totalValue}
                </Select.Option>
              </Select>
            </Col>
          </Row>
        }
      />
    </List.Item>
  )
}

export default ListItemVehicleHistory
